import script from "./BaseToast.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseToast.vue?vue&type=script&setup=true&lang=ts"

import "./BaseToast.vue?vue&type=style&index=0&id=d2934db8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2934db8"]])

export default __exports__